<template>
    <div class="home">
        <Toolbar />
        <Toolbox />

        <main>
            <!-- 左侧组件列表 -->
            <section class="left">
                <!-- <ComponentList /> -->
                <div @dragstart="handleDragStart" class="component-list">
                    <el-collapse v-model="activeNames" class="menu-collapse">
                        <!--管道编辑-->
                        <pipe-editor></pipe-editor>
                    </el-collapse>
                </div>
            </section>

            <!-- 中间画布 -->
            <section class="center">
                <div class="content" @drop="handleDrop" @dragover="handleDragOver">
                    <Editor />
                </div>
            </section>
        </main>
    </div>
</template>

<script>
import './assets/iconfont/iconfont.css'
import './styles/base.scss'

import Vue from 'vue'
Vue.prototype.$bus = new Vue(); // 事件总线

import Editor from './components/Editor/index'

import Toolbar from './components/Toolbar'
import Toolbox from './components/Toolbox'

import { getOffsetX,getOffsetY } from './utils/utils'
import { mapState } from 'vuex'

import './utils/directives'; // 可拖拽dialog

export default {
    components: { 
        Editor, Toolbar,Toolbox,
        PipeEditor:()=>import("./components/PipeEditor/PipeEditor"),
    },
    data() {
        return {
            activeNames:'pipeeditor',
        }
    },
    computed: mapState('simulation',[
        'map'
    ]),
    created() {
        // 禁用原生的鼠标右键操作，改为自定义右键操作
        document.addEventListener('contextmenu',function(e){
			e.preventDefault();
            e.stopPropagation();
		})
    },
    methods: {
        handleDrop(e) {
            e.preventDefault();
            e.stopPropagation();

            let groupid=e.dataTransfer.getData('groupid');
            let groupindex=e.dataTransfer.getData('groupindex');
            let childindex=e.dataTransfer.getData('childindex');
            // 原先的逻辑
            // 这里的除以2,不是很明白，因为在mac版本的firefox浏览器和windows下的浏览器的这个e.offsetX会有一定的差别
            // let xpixel=e.clientX;
            // let ypixel=e.clientY;


            // 新版逻辑，就是通过获取e.clientX距地图左上角的偏移量求x和y
            // 因为在第一次实现拖动的时候，e.target= div.ol-layer,
            // 第二次拖动节点的时候，e.target=canvas,也就是地图层，为什么会是这样，暂时不清楚
            // 为了消除这种差异，就使用了计算map.targetElement的top和当前的鼠标的clientx进行相减，获取xpixel的方法
            // console.log(e);
            let xpixel=getOffsetX(e,this.map);
            let ypixel=getOffsetY(e,this.map);

            
            // 创建管道节点
            this.$bus.$emit("createPipeNode",{
                groupid:groupid,
                groupindex:groupindex,
                childindex:childindex,
                coor:[xpixel,ypixel],
            });

        },
        // 拖动结束
        handleDragOver(e) {
            e.preventDefault();
            e.dataTransfer.dropEffect = 'copy';
        },
        // 开始拖拽
        handleDragStart(e) {
            // 设置拖拽数据
            e.dataTransfer.setData('groupid', e.target.dataset.groupid);
            e.dataTransfer.setData('groupindex', e.target.dataset.groupindex);
            e.dataTransfer.setData('childindex', e.target.dataset.childindex);
        },
    },
}
</script>

<style lang="scss">
.home {
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;

    main {
        height: calc(100% - 64px);
        position: relative;

        .left {
            position: absolute;
            height: 100%;
            width: 200px;
            left: 0;
            top: 0;
            padding-top: 10px;
            overflow: auto;
        }

        .right {
            position: absolute;
            height: 100%;
            width: 262px;
            right: 0;
            top: 0;
        }

        .center {
            margin-left: 200px;
            // margin-right: 262px;
            background: #f5f5f5;
            height: 100%;
            overflow: auto;
            padding: 10px;

            .content {
                width: 100%;
                height: 100%;
                overflow: auto;
            }
        }
    }

    .placeholder {
        text-align: center;
        color: #333;
    }
    /**
     *  组件列表
     */
    .component-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0 10px;

        .menu-collapse{
            width: 100%;
            border-top: none;
        }

        .list {
            width: 25%;
            cursor: grab;
            margin-bottom: 10px;
            text-align: center;
            color: #333;
            padding: 2px 5px;
            display: inline-block;
            align-items: center;
            justify-content: center;

            &:active {
                cursor: grabbing;
            }

            .iconfont {
                font-size: 25px;
            }

            // .icon-wenben,
            // .icon-tupian {
            //     font-size: 18px;
            // }
        }
        // 最后一行不显示边框
        .el-collapse-item:last-child{
            ::v-deep .el-collapse-item__wrap{
                border-bottom: none;
            }
        }
    }
}
</style>
